import { render, staticRenderFns } from "./CountryOverview.vue?vue&type=template&id=654f6be6&"
import script from "./CountryOverview.vue?vue&type=script&lang=js&"
export * from "./CountryOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports